import React, { useState } from 'react';
import { useSelector } from "react-redux";
import QuizFooterLoader from "./../Loader/QuizFooterLoader";
import { useTranslations, useStyles } from "examsbook-react-sdk/custom-hooks";
import CheckScoreModal from "../CheckScoreModal/checkScoreModal";
import OverlayButton from '../../../constants/OverlayButton';
import { Box, Grid, Button, Hidden } from '@material-ui/core';

/**
 * QuizFooter
 * @param props
 * @returns {*}
 * @constructor
 */
function QuizFooter(props) {
    const { isLoading, viewMode, hideNext, handleClick, drawerToggle, hidePrev, handleQuizPauseChange, setReset } = props;
    const quiz = useSelector((state) => state.quiz);
    const { duration, timeTaken, selectTimeFor } = quiz;
    const t = useTranslations();
    const selectedQuestion = useSelector((state) => state.selectedQuestion);
    const markButtonActive = selectedQuestion ? selectedQuestion.marked : false;
    const classes = useStyles(styles)();
    const questions = useSelector((state) => state.quiz.questions);
    const [ openScoreModel, setOpenScoreModel ] = useState(false);

    function handlerOpenCheckScore() {
        setOpenScoreModel(true);
    }

    function handlerCloseCheckScore() {
        setOpenScoreModel(false);
    }

    const handlePrev = () => {
        if (selectTimeFor === "QUESTION") {
            handleClick('next'); // This is "Skip" behavior
            handleQuizPauseChange(false);
            setReset(prev => !prev);
        } else {
            handleClick('prev');
            handleQuizPauseChange(false);
        }
    };

    const handleNext = () => {
        handleClick('next');
        handleQuizPauseChange(false);
        if (selectTimeFor === "QUESTION") {
            setReset(prev => !prev);
        }
    };

    const handleSubmit = () => {
        handleClick('submit');
        handleQuizPauseChange(false);
        if (selectTimeFor === "QUESTION") {
            setReset(prev => !prev);
        }
    };      

    return (
        !isLoading ?
            <React.Fragment>
                <CheckScoreModal viewMode={viewMode} open={openScoreModel} questions={questions}
                                 handlerCloseCheckScore={handlerCloseCheckScore} duration={duration}
                                 timeTaken={timeTaken}/>
                <Box className={`${classes.quizFooter} ${drawerToggle ? classes.quizFooterExpand : null}`}>

                    {viewMode ?
                        <Box className={markButtonActive ? classes.scorebtn + ' ' + classes.active : classes.scorebtn}>
                            <span className={classes.markForReview + ' ' + classes.checkScore}
                                  onClick={handlerOpenCheckScore}>Your Score</span>
                        </Box> : ''}

                    <Grid container className={classes.footerContainer}>
                        {/* Desktop layout*/}
                        <Hidden mdDown>
                            <Grid item xs={4} className={classes.alignLeft}>
                                <Button
                                    onClick={handlePrev}
                                    className={`
                                        ${classes.navButton} 
                                        ${classes.previousNextButton} 
                                        ${(selectTimeFor === "QUESTION" && hideNext) ||
                                            (selectTimeFor !== "QUESTION" && hidePrev)
                                            ? classes.disableBtn
                                            : ''
                                        }
                                        `}
                                >
                                    {selectTimeFor === "QUESTION" ? t('Skip') : t('Previous')}
                                </Button>
                            </Grid>
                            <Grid item xs={4} />
                            <Grid item xs={4} className={classes.alignRight}>
                                {!(viewMode && hideNext) && (
                                    <Button
                                        onClick={handleNext}
                                        className={`${classes.navButton} ${classes.previousNextButton} ${(viewMode || hideNext) ? classes.disableBtn : ''}`}
                                    >
                                        {t('Next')}
                                    </Button>
                                )}
                            </Grid>
                        </Hidden>
                        {/* Mobile/Tablet layout*/}
                        <Hidden lgUp>
                            <Grid item xs={12} className={classes.mobileActions}>
                                <Button
                                    onClick={handlePrev}
                                    className={`                                        
                                        ${classes.navButton} 
                                        ${classes.previousNextButton} 
                                        ${(selectTimeFor === "QUESTION" && hideNext) ||
                                            (selectTimeFor !== "QUESTION" && hidePrev)
                                            ? classes.disableBtn
                                            : ''
                                        }
                                        `}
                                >
                                    {selectTimeFor === "QUESTION" ? t('Skip') : t('Previous')}
                                </Button>
                                {!(viewMode && hideNext) && (
                                    <Button
                                        onClick={handleNext}
                                        className={`${classes.navButton} ${classes.previousNextButton} ${(viewMode || hideNext) ? classes.disableBtn : ''}`}
                                    >
                                        {t('Next')}
                                    </Button>
                                )}
                                {!(viewMode && hideNext) && (
                                    <OverlayButton
                                        onClick={handleSubmit}
                                        title={t('Submit')}
                                        classStyleHeading={`${classes.navButton} ${classes.submitButton}`}
                                        classStyleText={classes.submitText}
                                    >
                                        {!hideNext && <i className="fa fa-arrow-right" />}
                                    </OverlayButton>
                                )}
                            </Grid>
                        </Hidden>
                    </Grid>

                </Box>
            </React.Fragment> : 
            <Box className={classes.quizFooter}>
                <QuizFooterLoader/>
            </Box>
    );
}

const styles = theme => ({
    quizFooter: {
        position: 'fixed',
        bottom: 20,
        right: "7%",
        left: 340,
        color: '#fff',
        border: '1px',
        borderColor: 'black',
        borderRadius: '1px',
        transition: '0.3s all linear',
        padding: 0,
        overflow: 'hidden',
        zIndex: 9,
        backgroundColor: 'transparent',
        display: 'inline-block',
        textAlign: 'center',
        '@media (min-width:280px) and (max-width:767px)': {
            bottom: 15,
            right: 0,
            left: '0 !important',
            borderRadius: 0,
            display: 'flex !important',
            justifyContent: 'space-between',
            backgroundColor: 'transparent',
            padding: '0 0 10px',
        },
        '@media (min-width:768px) and (max-width:1024px)': {
            left: '2%',
            width: '95%',
        },
    },
    quizFooterExpand: {
        left: 10,
        '@media (min-width:768px) and (max-width:1023px)': {
           left: '350px',
           zIndex: 9
        },
        '@media (min-width:1024px) and (max-width:1024px)': {
            left: '310px'
        },
    },
    prevTextAlign:{
        '@media (min-width:280px) and (max-width:767px)': {
            paddingLeft: '4px'
        },
    },
    markBtn: {
        float: 'none',
        width: 'auto',
        textAlign: 'left',
        backgroundColor: '#fff',
        display: 'inline-block',
        '@media (max-width: 767px)': {
            backgroundColor: 'transparent',
        }
    },
    scorebtn: {
        float: 'none',
        width: 'auto',
        textAlign: 'left',
        backgroundColor: '#fff',
        display: 'inline-block',
        '@media (max-width: 767px)': {
            backgroundColor: 'transparent',
            display: 'none'
        }
    },
    active: {
        ConvolverNode: '#0b2f8a',
        '& span': {
            color: '#fff',
        }
    },
    markForReview: {
        width: 'auto',
        display: 'inline-block',
        padding: 14,
        paddingLeft: 30,
        paddingRight: 30,
        borderRadius: 5,
        textAlign: 'center',
        fontSize: 16,
        marginLeft: 0,
        cursor: 'pointer',
        fontWeight: 600,
        color: '#0039cb',
        '@media (max-width:767px)': {
            paddingLeft: 0,
            padding: 0,
            paddingRight: 0,
            fontSize: 13,
        }
    },
    checkScore: {
        display: 'none',
        '@media (max-width:767px)': {
            display: 'block'
        }
    },
    footerContainer: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        padding: '8px 16px',
        '@media (min-width: 440px) and (max-width: 1100px)': {
            padding: 0,
        },
        '@media (max-width: 1100px)': {
            flexDirection: 'column',
        },
    },
    alignLeft: {
        display: 'flex',
        justifyContent: 'flex-start',
    },
    alignRight: {
        display: 'flex',
        justifyContent: 'flex-end',
    },
    mobileActions: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: '8px',
    },
    navButton: {
        flex: 'none',
        width: 'auto',
        padding: '6px 20px',
        textAlign: 'center',
        textTransform: 'capitalize',
        borderRadius: '4px',
    },
    previousNextButton: {
        border: '1px solid #000000B2',
        backgroundColor: '#fff',
        color: '#000',
        fontWeight: 400,
        '&:hover': {
            color: '#000',
            backgroundColor: 'rgba(0, 0, 0, 0.04)'
        },
    },
    submitButton: {
        fontWeight: 500,
        color: '#FAFAFA',
        backgroundColor: '#0C3450',
        '&:hover': {
            backgroundColor: '#0c3450e0 !important',
        },
    }, 
    disableBtn: {
        cursor: 'not-allowed',
        opacity: 0.5,
    },                
});
export default QuizFooter;
